import { BUYER } from "@/constants/Buyer";
export default {
    methods: {
        requestCancel() {
            window.open(BUYER.LINK_REQUEST_CENCELABLE, '_blank');
        },
    },
  };